import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { JSX } from "react";

export interface AppList<T> {
	airportal?: T;
	all?: T;
	rthe?: T;
}

export const enum BlockedTab {
	BLOCKED,
	PLEDGE,
}

export interface ButtonsAction {
	cancel?: (() => void) | null;
	ok: (() => void) | null;
}

export interface DeviceInfo {
	id: number;
	ip: string;
	userAgent: string;
}

export interface DeviceResponse {
	current: DeviceInfo;
	other: DeviceInfo[];
}

export interface DialogInfo {
	countdown?: number;
	isHtml?: boolean;
	showCancel?: boolean;
	text?: string;
	title?: string;
}

export interface DynamicInfo {
	alert?: string;
	backend?: string;
	blockReason?: string;
	isLoaded?: boolean;
	isTwinkstar?: boolean;
	login?: LoginInfo | string;
	redirectTo?: string;
	region?: string;
	sw?: boolean;
}

export interface ExpirationTimeInfo {
	data?: number;
	time?: number;
}

export interface LoginInfo {
	birthday?: string;
	email?: string;
	name?: string;
	phone?: string;
	token?: string;
	username?: string;
}

export const enum LoginTab {
	LOGIN,
	SIGN_UP,
	RESET_PASSWORD,
	SET_PHONE,
	TFA_SMS,
	TFA_TOTP,
}

export interface LoginResponse extends LoginInfo {
	action?: string;
	block?: {
		autoBlock: boolean;
		reason: string;
	};
	alert?: string;
	link?: string;
	nextAction?: string;
	success?: boolean;
}

interface MobileAppCallback {
	postMessage: (data: string) => void;
}

export interface OptionsItem<T> {
	icon?: IconProp;
	text?: string;
	value?: T;
	when?: boolean;
}

export interface OrderInfo {
	amount: number;
	method: PaymentMethod;
	orderNumber: string;
	product: "airportalPremiumData" | "extraDownloads" | "webHostingPremium";
	time: number;
}

export interface PasswordChecklist {
	hasLowercase: boolean;
	hasNoCommonCombinations: boolean;
	hasNoConsecutiveNumbers: boolean;
	hasUppercase: boolean;
	isLongEnough: boolean;
}

export const enum PaymentMethod {
	ALIPAY = "alipay",
	APP_STORE = "appstore",
	PAYPAL = "paypal",
	WECHAT_PAY = "wechatpay",
}

export interface PaymentMethodInfo {
	callback: (options: {
		url: string;
		setQrCode?: (newValue: string) => void;
		setShowCashier: (newValue: boolean) => void;
	}) => Promise<void>;
}

export interface PaymentQuery {
	amount?: number;
	appName?: string;
	month?: number;
	[key: string]: string | number | undefined;
}

export interface PlanLength {
	"month-1": number | PriceDetail;
	"month-3": number | PriceDetail;
	"month-12": number | PriceDetail;
}

export const enum PremiumApp {
	AIRPORTAL = "airportal",
	WEB_HOSTING = "webHosting",
}

export interface PremiumInfo {
	appName?: PremiumApp;
	copy?: string;
	data?: number;
	days?: number;
	explanation?: string;
	link?: string;
	originalPrice?: PlanLength;
	price?:
		| PlanLength
		| PriceDetail
		| {
				airportal: PriceDetail;
				rthe: PriceDetail;
		  };
	privileges?: string[];
	promotionText?: string;
}

export interface PriceDetail {
	original: number;
	special: number;
}

export interface PriceItem {
	key?: number;
	originalPrice?: number;
	price?: number;
	text?: string;
}

export interface PrivilegesInfo {
	appName?: PremiumApp;
	explanation?: string;
	privileges?: string[];
}

export interface ProfileCardItem {
	action: {
		onClick: () => void | Promise<void>;
		text: string;
		title: string;
	};
	content?: string;
	icon: IconProp;
	jsx?: JSX.Element;
	label: string;
}

export interface ProfileResponse {
	realIdLevel?: RealIdLevel;
	realName?: string;
	region: string;
	regTime?: {
		details: string;
		time: string;
	};
	tfa: boolean;
}

export interface PromptInfo {
	autoComplete?: string;
	countdown?: number;
	countdownText?: string;
	defaultText?: string;
	inlineActionName?: string;
	text?: string;
	type?: string;
}

const enum RealIdLevel {
	NO_REAL_ID,
	EMAIL_VERIFIED,
	PHONE_VERIFIED,
	REAL_ID_VERIFIED,
}

export interface WindowExt extends Window {
	rth?: MobileAppCallback;
	TencentCaptcha?: typeof TencentCaptcha;
	webkit?: {
		messageHandlers: {
			rth: MobileAppCallback;
		};
	};
}
